import React, { Component } from 'react';
import { uploadEventPoster } from '../utils/imageApi';

var config = process.env;

// Form reutilizable de evento. Modo alta y modo edición comparten campos; en edición
// se precargan desde props.initial. Emite el payload normalizado por props.onChangeData(value).
// El poster se sube a Firebase (single-image) y se guarda como posterUrl.
class FormEventComponent extends Component {
    constructor(props) {
        super(props);
        const initial = props.initial || {};
        // El evento viene del backend en snake_case; se lee snake_case con fallback a camel.
        const branchId = initial.branch_id != null ? initial.branch_id : initial.branchId;
        const startsAt = initial.starts_at != null ? initial.starts_at : initial.startsAt;
        const endsAt = initial.ends_at != null ? initial.ends_at : initial.endsAt;
        const isFree = initial.is_free != null ? initial.is_free : initial.isFree;
        const requiresHolderInfo = initial.requires_holder_info != null ? initial.requires_holder_info : initial.requiresHolderInfo;
        const freeMaxPerAccount = initial.free_max_per_account != null ? initial.free_max_per_account : initial.freeMaxPerAccount;
        const posterUrl = (initial.poster_url != null ? initial.poster_url : initial.posterUrl) || '';
        // Jornadas del club: un evento privado no se lista en la web, pero se vende igual
        // (mostrador o link directo). El backend guarda 'public' | 'private'.
        const visibility = initial.visibility || 'public';
        this.state = {
            title: initial.title || '',
            description: initial.description || '',
            branchId: branchId != null ? String(branchId) : '',
            startsAt: this.toLocalInput(startsAt),
            endsAt: this.toLocalInput(endsAt),
            capacity: initial.capacity != null ? initial.capacity : '',
            slug: initial.slug || '',
            // ENI-215: link a la planilla de puntajes. Interno: no se publica en la web.
            sheetUrl: (initial.sheet_url != null ? initial.sheet_url : initial.sheetUrl) || '',
            // FR-020: nota interna de la jornada ("traer los mazos de la liga", "falta
            // confirmar el juez"). El backend la borra del JSON público, así que es el lugar
            // donde el equipo puede escribir sin pensar en el cliente.
            notes: initial.notes || '',
            isFree: !!isFree,
            requiresHolderInfo: !!requiresHolderInfo,
            isPrivate: visibility === 'private',
            freeMaxPerAccount: freeMaxPerAccount != null ? freeMaxPerAccount : '',
            posterUrl,
            branches: [],
            posterFile: null,
            posterPreview: posterUrl,
            uploading: false,
            // Entrada inicial (solo en alta): el precio vive en el tipo de entrada.
            ticketName: 'General',
            ticketPrice: '',
            ticketKind: 'general',
        };
    }

    componentDidMount() {
        this.loadBranches();
    }

    // Sólo mostrador: el evento nació del alta de eventos privados (`counter_only`).
    isCounterOnly = () => !!Number((this.props.initial || {}).counter_only);

    // datetime-local necesita "YYYY-MM-DDTHH:mm"; el back puede mandar ISO con segundos/zona.
    toLocalInput = (value) => {
        if (!value) return '';
        return String(value).slice(0, 16);
    }

    loadBranches = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
        };
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch`, request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    // ENI-116: leer el mensaje de negocio anidado si viene (data.data.message), si no el genérico
                    alert((data.data && data.data.message) || data.message);
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    const branches = data.data || [];
                    this.setState((prev) => ({
                        branches,
                        branchId: prev.branchId || (branches[0] ? String(branches[0].id) : ''),
                    }));
                }
            })
            .catch((error) => {
                console.error('No se pudieron cargar las sucursales:', error);
                alert('Error de conexión');
            });
    }

    handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        this.setState({ [name]: type === 'checkbox' ? checked : value });
    }

    handlePosterChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        this.setState({ posterFile: file, posterPreview: URL.createObjectURL(file) });
    }

    // Sube el poster pendiente y devuelve la URL (o null si falla / no hay archivo).
    // Limpia posterFile en éxito para que deje de considerarse "pendiente de subir".
    //
    // ENI-167: va por el backend, que le pone el nombre al objeto y valida tipo y tamaño. Antes
    // el nombre lo armaba el front como `poster_${Date.now()}.webp` — con extensión .webp aunque
    // el archivo fuera PNG o JPG.
    uploadPoster = async () => {
        if (!this.state.posterFile) {
            alert('Elegí una imagen antes de subir.');
            return null;
        }
        this.setState({ uploading: true });
        try {
            const subido = await uploadEventPoster(this.state.posterFile, this.state.posterFile.name);
            this.setState({ posterUrl: subido.url, posterPreview: subido.url, posterFile: null, uploading: false });
            return subido.url;
        } catch (error) {
            console.error('Error al subir el poster:', error);
            // ENI-153: mostrar el motivo real en vez de un mensaje genérico. Ahora el motivo lo
            // da el backend ("La imagen pesa X MB…", "Sólo se aceptan imágenes…"), que es
            // accionable por quien está en la pantalla.
            const detail = error && error.message ? `: ${error.message}` : '.';
            alert(`Hubo un error al subir el poster${detail}`);
            this.setState({ uploading: false });
            return null;
        }
    }

    // ENI-154: quita el poster cargado (deja el evento sin imagen). En edición, buildPayload
    // manda posterUrl:null para que el PATCH limpie la columna.
    onClickRemovePoster = () => {
        this.setState({ posterFile: null, posterUrl: '', posterPreview: '' });
    }

    // Handler del botón "Subir poster": sube y avisa al usuario.
    onClickUploadPoster = async () => {
        const url = await this.uploadPoster();
        if (url) {
            alert('Poster subido con éxito.');
        }
    }

    isValid = () => {
        if (this.state.title.trim() === '') return false;
        if (String(this.state.branchId).trim() === '') return false;
        if (String(this.state.startsAt).trim() === '') return false;
        return true;
    }

    // En modo edición los opcionales vacíos se mandan como null para que el PATCH los limpie.
    // En alta se omiten (se quedan con el default del back).
    buildPayload = (overrides = {}) => {
        const editMode = !!this.props.editMode;
        const posterUrl = overrides.posterUrl !== undefined ? overrides.posterUrl : this.state.posterUrl;
        const payload = {
            title: this.state.title.trim(),
            branchId: parseInt(this.state.branchId, 10),
            startsAt: this.state.startsAt,
            isFree: !!this.state.isFree,
            requiresHolderInfo: !!this.state.requiresHolderInfo,
            visibility: this.state.isPrivate ? 'private' : 'public',
        };

        const description = this.state.description.trim();
        if (description !== '') payload.description = description;
        else if (editMode) payload.description = null;

        const endsAt = String(this.state.endsAt).trim();
        if (endsAt !== '') payload.endsAt = this.state.endsAt;
        else if (editMode) payload.endsAt = null;

        const capacity = String(this.state.capacity).trim();
        if (capacity !== '') payload.capacity = parseInt(this.state.capacity, 10);
        else if (editMode) payload.capacity = null;

        const slug = this.state.slug.trim();
        if (slug !== '') payload.slug = slug;
        else if (editMode) payload.slug = null;

        // ENI-215: vacío en edición limpia la columna (mismo criterio que el resto).
        const sheetUrl = String(this.state.sheetUrl).trim();
        if (sheetUrl !== '') payload.sheetUrl = sheetUrl;
        else if (editMode) payload.sheetUrl = '';

        const freeMaxPerAccount = String(this.state.freeMaxPerAccount).trim();
        if (freeMaxPerAccount !== '') payload.freeMaxPerAccount = parseInt(this.state.freeMaxPerAccount, 10);
        else if (editMode) payload.freeMaxPerAccount = null;

        // FR-020: misma regla que el resto de los opcionales — vacío en edición limpia la
        // columna (`updateEvent` hace `patch.notes = body.notes || null`).
        const notes = String(this.state.notes).trim();
        if (notes !== '') payload.notes = notes;
        else if (editMode) payload.notes = null;

        // ENI-154: en edición, un poster vacío se manda como null para que el PATCH lo limpie.
        if (posterUrl) payload.posterUrl = posterUrl;
        else if (editMode) payload.posterUrl = null;
        return payload;
    }

    // Entrada inicial que se crea junto con el evento (solo en alta).
    buildInitialTicketType = () => {
        if (this.state.isFree) {
            return { name: 'Entrada libre', price: 0, kind: 'free' };
        }
        return {
            name: this.state.ticketName.trim() || 'General',
            price: parseInt(this.state.ticketPrice, 10) || 0,
            kind: this.state.ticketKind || 'general',
        };
    }

    submit = async () => {
        if (!this.isValid()) {
            alert('Completá título, sucursal y fecha de inicio.');
            return;
        }
        const editMode = !!this.props.editMode;
        // ENI-155: el póster es obligatorio para CREAR el evento (en edición se puede quitar).
        if (!editMode && !this.state.posterUrl && !this.state.posterFile) {
            alert('Subí un póster antes de crear el evento.');
            return;
        }
        // En alta, si el evento NO es gratis, exigir un precio para la entrada inicial.
        if (!editMode && !this.state.isFree && String(this.state.ticketPrice).trim() === '') {
            alert('Poné el precio de la entrada (o marcá "Entrada gratuita").');
            return;
        }
        // Si hay un poster elegido pero no subido todavía, subirlo antes de armar el payload
        // para no descartarlo en silencio.
        let posterUrl = this.state.posterUrl;
        if (this.state.posterFile) {
            posterUrl = await this.uploadPoster();
            if (!posterUrl) {
                return; // la subida falló (uploadPoster ya avisó); no guardamos
            }
        }
        if (editMode) {
            this.props.onChangeData(this.buildPayload({ posterUrl }));
        } else {
            // En alta: evento + entrada inicial (el AddEventPage los crea en secuencia).
            this.props.onChangeData(this.buildPayload({ posterUrl }), this.buildInitialTicketType());
        }
    }

    field(label, name, type = 'text', extra = {}) {
        return (
            <div className="form-group">
                <label>{label}</label>
                <input
                    type={type}
                    name={name}
                    className="form-control"
                    value={this.state[name]}
                    onChange={this.handleChange}
                    {...extra}
                />
            </div>
        );
    }

    render() {
        const editMode = !!this.props.editMode;
        return (
            <div className="card card-small mb-4">
                <div className="card-body p-4">
                    <h6 className="text-uppercase text-muted">Datos del evento</h6>
                    <div className="row">
                        <div className="col-md-6">{this.field('Título *', 'title')}</div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Sucursal *</label>
                                <select name="branchId" className="form-control" value={this.state.branchId} onChange={this.handleChange}>
                                    <option value="">Seleccionar…</option>
                                    {this.state.branches.map((b) => (
                                        <option key={b.id} value={b.id}>{b.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">{this.field('Slug', 'slug')}</div>
                    </div>

                    <div className="form-group">
                        <label>Descripción</label>
                        <textarea name="description" className="form-control" rows="3" value={this.state.description} onChange={this.handleChange} />
                    </div>

                    <div className="row">
                        <div className="col-md-3">{this.field('Inicio *', 'startsAt', 'datetime-local')}</div>
                        <div className="col-md-3">{this.field('Fin', 'endsAt', 'datetime-local')}</div>
                        <div className="col-md-3">{this.field('Cupo', 'capacity', 'number')}</div>
                        <div className="col-md-3">{this.field('Máx. gratis por cuenta', 'freeMaxPerAccount', 'number')}</div>
                    </div>

                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="d-block">Entrada gratuita</label>
                                <input type="checkbox" name="isFree" checked={this.state.isFree} onChange={this.handleChange} /> Sí
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="d-block">Requiere datos del asistente</label>
                                <input type="checkbox" name="requiresHolderInfo" checked={this.state.requiresHolderInfo} onChange={this.handleChange} /> Sí
                            </div>
                        </div>
                        {/* Jornadas del club: privado = no aparece en el listado de la web. Se
                            vende en el mostrador y, si se comparte el link, también online.
                            Un evento sólo mostrador (`counter_only`, los del alta de eventos
                            privados) no ofrece la casilla: la web no lo abre ni por link, así
                            que «se vende por link directo» sería mentira y destildarla no lo
                            abriría. La visibilidad viaja como estaba. */}
                        {!this.isCounterOnly() && (
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="d-block">Evento privado (jornada del club)</label>
                                    <input type="checkbox" name="isPrivate" checked={this.state.isPrivate} onChange={this.handleChange} /> Sí
                                    <small className="d-block text-muted">No se lista en la web; se vende acá y por link directo.</small>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* FR-020: la nota interna del equipo. Va junto a la planilla porque las dos
                        son datos internos: no se publican y no las ve el cliente. La distinción
                        con "Descripción" es exactamente ésa, y por eso el rótulo la nombra. */}
                    <div className="form-group">
                        <label>Nota interna (no se publica)</label>
                        <textarea name="notes" className="form-control" rows="2"
                            placeholder="Para el equipo: qué hay que preparar, quién trae qué, avisos de la jornada."
                            value={this.state.notes} onChange={this.handleChange} />
                    </div>

                    {/* ENI-215: la planilla externa (Drive, Sheets) era el único lugar donde llevar
                        los puntajes, así que ocupaba un campo entero en el medio del formulario.
                        Ahora los puntajes viven en el torneo del evento, que es la opción buena;
                        la planilla queda para los casos que no encajan y para los eventos viejos
                        que ya la tienen. Se pliega: sigue estando, deja de competir por atención.
                        Arranca abierta si el evento YA tiene una, porque esconder un dato cargado
                        es peor que mostrar un campo de más. */}
                    <div className="form-group">
                        {this.state.verPlanilla || this.state.sheetUrl ? (
                            <>
                                <label style={{ fontSize: 13 }}>Link a planilla externa (opcional)</label>
                                <input type="url" name="sheetUrl" className="form-control form-control-sm"
                                    placeholder="https://docs.google.com/spreadsheets/..."
                                    value={this.state.sheetUrl} onChange={this.handleChange} />
                                <small className="text-muted">
                                    Interno: sólo lo ve el equipo. Si el evento lleva puntajes, conviene el
                                    <strong> torneo</strong> —se carga desde el sistema y arma las mesas— y dejar esto vacío.
                                </small>
                            </>
                        ) : (
                            <button type="button" className="btn btn-sm btn-white"
                                onClick={() => this.setState({ verPlanilla: true })}>
                                + Link a planilla externa
                            </button>
                        )}
                    </div>

                    {!editMode && (
                        <>
                            <hr />
                            <h6 className="text-uppercase text-muted">Entrada inicial</h6>
                            <p className="text-muted" style={{ fontSize: '0.85rem' }}>El precio va por tipo de entrada. Después de crear el evento vas a poder agregar más tipos (early-bird, socio, etc.).</p>
                            {this.state.isFree ? (
                                <p className="text-muted">Evento gratuito: se crea una entrada libre (precio 0).</p>
                            ) : (
                                <div className="row">
                                    <div className="col-md-4">{this.field('Nombre de la entrada', 'ticketName')}</div>
                                    <div className="col-md-3">{this.field('Precio *', 'ticketPrice', 'number')}</div>
                                </div>
                            )}
                        </>
                    )}

                    <hr />
                    <h6 className="text-uppercase text-muted">{editMode ? 'Poster' : 'Poster *'}</h6>
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            {this.state.posterPreview && (
                                <div className="d-flex justify-content-center">
                                    <img src={this.state.posterPreview} alt="Vista previa poster" width="120" style={{ marginBottom: '12px' }} />
                                </div>
                            )}
                            <input type="file" accept="image/*" onChange={this.handlePosterChange} />
                            <div className="mt-2">
                                <button type="button" className="btn btn-outline-secondary btn-sm" disabled={this.state.uploading} onClick={this.onClickUploadPoster}>
                                    {this.state.uploading ? 'Subiendo…' : 'Subir poster'}
                                </button>
                                {/* ENI-154: quitar el poster cargado (dejar el evento sin imagen). */}
                                {this.state.posterPreview && (
                                    <button type="button" className="btn btn-outline-danger btn-sm ml-2" disabled={this.state.uploading} onClick={this.onClickRemovePoster}>
                                        Quitar poster
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    <button type="button" className="btn btn-accent" disabled={this.props.disabled} onClick={this.submit}>
                        {editMode ? 'Guardar cambios' : 'Crear evento'}
                    </button>
                </div>
            </div>
        );
    }
}

export default FormEventComponent;
